export var CollaboratorTaskAccessLevel;
(function (CollaboratorTaskAccessLevel) {
    CollaboratorTaskAccessLevel[CollaboratorTaskAccessLevel["Internal"] = 0] = "Internal";
    CollaboratorTaskAccessLevel[CollaboratorTaskAccessLevel["External"] = 1] = "External";
})(CollaboratorTaskAccessLevel || (CollaboratorTaskAccessLevel = {}));
